import { Link } from "react-router-dom";
import BrainMark from "@/components/BrainMark";

const COLUMNS = [
  {
    title: "مقایسه سرویس‌ها",
    links: [
      { label: "لیارا", to: "/compare/liara" },
      { label: "چابکان", to: "/compare/chabokan" },
      { label: "پارس‌پک", to: "/compare/parspack" },
      { label: "ابر آروان", to: "/compare/arvancloud" },
    ],
  },
  {
    title: "سرویس‌های ابری",
    links: [
      { label: "هاست رایگان", to: "/free-host" },
      { label: "سکوی ابری", to: "/products/paas" },
      { label: "ایجنت‌های هوش مصنوعی", to: "/agents" },
      { label: "افزونه‌های مدیریت‌شده", to: "/products/databases" },
      { label: "بازارچه سرویس‌ها", to: "/marketplace" },
      { label: "دی‌ان‌اس ابری", to: "/products/dns" },
    ],
  },
  {
    title: "میزبانی زبان‌ها و فریم‌ورک‌ها",
    links: [
      { label: "هاست وردپرس", to: "/products/wordpress" },
      { label: "هاست پایتون", to: "/products/python" },
      { label: "هاست نود جی‌اس", to: "/products/nodejs" },
      { label: "هاست لاراول", to: "/products/laravel" },
      { label: "هاست گو", to: "/products/go" },
      { label: "هاست Next.js", to: "/products/nextjs" },
      { label: "هاست React", to: "/products/react" },
      { label: "سایت استاتیک", to: "/products/static-sites" },
    ],
  },
  {
    title: "پشتیبانی و مستندات",
    links: [
      { label: "راهنماهای استقرار", to: "/guides" },
      { label: "مستندات فنی", to: "/support/docs" },
      { label: "ابزار خط فرمان (CLI)", to: "https://get.gerdoo.cloud" },
      { label: "وضعیت سرویس‌ها", to: "https://gerdoocloudstatus.ir" },
      { label: "وبلاگ", to: "/blog" },
      { label: "درباره گردو کلاد", to: "/info/about" },
      { label: "تماس با ما", to: "/contact" },
    ],
  },
  {
    title: "قوانین و مقررات",
    links: [
      { label: "شرایط استفاده از خدمات", to: "/legal/terms" },
      { label: "حفظ حریم خصوصی", to: "/legal/privacy" },
      { label: "توافق‌نامه سطح خدمات (SLA)", to: "/legal/sla" },
    ],
  },
];

export function Footer() {
  return (
    <footer data-pagefind-ignore="all" className="bg-muted">
      <div className="mx-auto max-w-[1200px] px-8 py-12 sm:px-12">
        <div className="mb-10 max-w-md text-start">
          <Link to="/" className="mb-3 flex items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded-[6px] bg-gerdoo-600">
              <BrainMark className="h-3.5 w-3.5 text-white" />
            </span>
            <span className="text-[13px] font-semibold tracking-tight text-foreground">گردو</span>
          </Link>
          <p className="text-[13px] leading-7 text-muted-foreground">
            از اولین نسخه تا رشد محصول، گردو همراه شماست؛ با میزبانی ابری، دیتابیس‌های مدیریت‌شده و زیرساختی که با نیاز شما گسترش پیدا می‌کند.
          </p>
        </div>
        <div className="mb-10 grid grid-cols-2 gap-8 text-start sm:grid-cols-3 lg:grid-cols-5">
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h2 className="mb-3 text-[12px] font-semibold text-foreground">{col.title}</h2>
              <ul className="space-y-2 text-[12px] text-muted-foreground">
                {col.links.map((l) => (
                  <li key={l.to}>
                    {/* /blog and /support/docs are separate apps, not SPA routes: full navigation. */}
                    {l.to.startsWith("mailto:") || l.to.startsWith("http") || l.to === "/blog" || l.to.startsWith("/support/docs") ? (
                      <a href={l.to} className="transition-opacity hover:opacity-70 hover:text-foreground">
                        {l.label}
                      </a>
                    ) : (
                      <Link to={l.to} className="transition-opacity hover:opacity-70 hover:text-foreground">
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-border pt-6 text-[12px] text-muted-foreground sm:flex-row">
          <div className="flex flex-col items-center gap-4 sm:flex-row">
            <span>© {new Date().getFullYear()} گردو. تمام حقوق این وب‌سایت متعلق به گردو است.</span>
            <a
              className="inline-flex shrink-0 items-center rounded-lg bg-card p-1 transition-opacity hover:opacity-70"
              referrerPolicy="origin"
              target="_blank"
              rel="noopener noreferrer"
              href="https://trustseal.enamad.ir/?id=741961&Code=xY5Mh9O6lfsJXddnzWGBoFQVwFzyAom0"
              aria-label="نماد اعتماد الکترونیکی"
            >
              <img
                src="/enamad.png"
                alt="نماد اعتماد الکترونیکی"
                width={125}
                height={136}
                className="h-10 w-auto"
                loading="lazy"
                decoding="async"
              />
            </a>
          </div>
          <div className="flex items-center gap-6">
            <a href="https://t.me/gerdoocloud" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-70 hover:text-foreground">تلگرام</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
